
const lang = document.querySelector("html").getAttribute("lang");
let smartformEmailValidationMessage;

import(`Locale/${lang}.json`).then((module) => {
    smartformEmailValidationMessage = module.Validate.smartformEmail || "Please enter a valid email address.";
});

function initSmartForm(code, callback = () => {}) {
    var scriptTag = document.createElement('script');

    window.smartform = window.smartform || {};
    window.smartform.beforeInit = function () {
        window.smartform.setClientId(code);
    };
    window.smartform.afterInit = callback;

    scriptTag.src = 'https://client.smartform.cz/v2/smartform.js';
    scriptTag.async = true;

    document.head.appendChild(scriptTag);
}

function initSmartFormInput(id, country = 1, inputs = {}) {
    setCountryForSmartformInstance(id, country);

    window.smartform.getInstance(id).addressControl.addValidationCallback(function (result) {
        result = result.result;

        var addressArray = result.addressArray;
        if (result.type == window.smartform.AddressValidationResultType.HIT) {
            if (addressArray[0]) {
                document.querySelector('input[name="' + inputs['address'] + '"]').value = addressArray[0].STREET + ' ' + addressArray[0].WHOLE_NUMBER;
                document.querySelector('input[name="' + inputs['city'] + '"]').value = addressArray[0].CITY.split(' - ')[0];
                document.querySelector('input[name="' + inputs['postCode'] + '"]').value = addressArray[0].ZIP;
            }
        } else {
            // clean
        }
    });
}

function setCountryForSmartformInstance(id, country) {
    var countryMap = {
        1: 'SK',
        56: 'CZ'
    };

    if (window.smartform.getInstance === undefined) {
        return;
    }

    if (countryMap[country] == undefined) {
        window.smartform.getInstance(id).addressControl.setAllSuggestionsEnabled(false);
        document.querySelector('.' + id).disabled = true;
        return;
    }

    window.smartform.getInstance(id).addressControl.setAllSuggestionsEnabled(true);
    document.querySelector('.' + id).disabled = false;
    window.smartform.getInstance(id).addressControl.setCountry(countryMap[country]);
}

function destroySmartform(id) {
    window.smartform.unbindForm(id);
}

jQuery.validator.addMethod(
    "smartformEmail",
    function (value, element, param) {
        const classes = element.classList;
        var instance = null;

        for (const cl of classes) {
            if (cl.includes("smartform-instance")) {
                instance = cl;
                break;
            }
        }

        const lastResult = window.smartform
            .getInstance(instance)
            .emailControl.getLastValidationResult();

        const acceptableResults = ["EXISTS", "UNKNOWN"];

        if (!lastResult) {
            return true;
        }

        return lastResult.upToDate && acceptableResults.includes(lastResult.result.resultType);
    },
    jQuery.validator.format("Please enter a valid email address.")
);

// smartform email validation callback
window.emailValidationCallback = function (response) {
    const emailField = $(".smartform-email:visible");
    const form = emailField.parents("form:visible");

    if (form) {
        form.data("validator").element(emailField);
    }
};

// smartform init
const initAllSmartForms = () => {
    const smartformTriggers = document.querySelectorAll(".js-smartform-trigger");

    initSmartForm("kVt2jvyFqR", function () {
        if (smartformTriggers.length > 0) {
            for (const trigger of smartformTriggers) {
                const type = trigger.dataset.type;

                initSmartFormInput(
                    `smartform-instance-${type}`,
                    document.querySelector(`[data-type="${type}-country"]`).value,
                    {
                        address: document.querySelector(`[data-type="${type}-address"]`).attributes
                            .name.value,
                        city: document.querySelector(`[data-type="${type}-city"]`).attributes.name
                            .value,
                        postCode: document.querySelector(`[data-type="${type}-post-code"]`)
                            .attributes.name.value,
                    }
                );
            }
        }

        window.smartform.getInstanceIds().forEach(function (instance) {
            const smartformInstance = window.smartform.getInstance(instance);

            if (smartformInstance.emailControl) {
                smartformInstance.emailControl.addValidationCallback(window.emailValidationCallback);

                setTimeout(function () {
                    const $field = $("." + instance);

                    if ($field.length) {
                        $field.rules("add", {
                            smartformEmail: true,
                            messages: {
                                smartformEmail: smartformEmailValidationMessage,
                            },
                        });
                    }
                }, 1000);
            }
        });
    });
};

window.initAllSmartForms = initAllSmartForms;

export { initAllSmartForms };
